export const SEARCH_INPUT_DEFAULT_PLACEHOLDER = 'Search for Contact';
export const FILTER_AND_SORT_RECENT_ACTIVITIES_TITLE =
  'Filter & Sort Recent Activities';
export const FILTER_AND_SORT_UPCOMING_ACTIVITIES_TITLE =
  'Filter & Sort Upcoming Activities';
export const FILTER_AND_SORT_TEXT = 'Filter & Sort';
export const TICKER_TEXT = 'Ticker';
export const SEARCH_SECURITIES_PLACEHOLDER = 'Search For Securities';
